<template>
  <v-card>
    <v-card-text class="text--primary">
      <v-row dense>
        <v-col cols="12" sm="8">
          <p class="mb-1">
            <v-chip label class="mb-2">{{ venda.id }}</v-chip>
            <span class="headline text--primary">
                {{ venda.grupoCompra.nome }}
              </span>
            <px-situacao-compra-tag :situacao="venda.situacaoFornecedor" />
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <px-responsaveis :responsaveis="venda.fornecedoresReponsaveis"
                           custom-path="compras-conjuntas"
                           :id="venda.id"
                           @update="onMovimentar"/>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    venda: Object,
  },
  methods: {
    onMovimentar() {
      this.$emit('movimentar');
    },
  },
};
</script>
